import { hslToRgb } from "./hsl-to-rgb";
import { rgbToHex } from "./rgb-to-hex";

/**
 * Converts HSL color values to a hex color string.
 *
 * @param h Hue (0-360)
 * @param s Saturation (0-1)
 * @param l Lightness (0-1)
 * @returns A hex color string (e.g., "#a1b2c3")
 */
export const hslToHex = (h: number, s: number, l: number): string => {
  const [r, g, b] = hslToRgb(h, s, l);
  return rgbToHex(r, g, b);
};
